import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {AccessService} from "../../services/access.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-supplier-list',
    imports: [RouterLink, NgIf, PaginationComponent, FormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-boxes-packing me-2"></i>Lieferanten <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/supplier', 0]">Lieferant anlegen</button>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th (click)="setOrder('name')">
                                    Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('zip')">
                                    PLZ <i class="fa-solid" *ngIf="predicate == 'zip'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('city')">
                                    Ort <i class="fa-solid" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('street')">
                                    Straße <i class="fa-solid" *ngIf="predicate == 'street'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('email_masterdata')">
                                    E-Mail Stammdaten <i class="fa-solid" *ngIf="predicate == 'email_masterdata'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('email_order')">
                                    E-Mail Bestellung <i class="fa-solid" *ngIf="predicate == 'email_order'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (entry of entries; track entry.id) {
                                    <tr [routerLink]="['/supplier', entry.id]">
                                        <td>{{ entry.name }}</td>
                                        <td>{{ entry.zip }}</td>
                                        <td>{{ entry.city }}</td>
                                        <td>{{ entry.street }}</td>
                                        <td>
                                            @if (entry.email_masterdata) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + entry.email_masterdata">{{ entry.email_masterdata }}</a> }
                                        </td>
                                        <td>
                                            @if (entry.email_order) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + entry.email_order">{{ entry.email_order }}</a> }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    `
})
export class SupplierListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Supplier/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.suppliers;
        });
    }

}
